import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, RevealLineOnScroll } from "./Reveal";
import { ECOSYSTEM, EASE } from "../data";

export const Ecosystem = () => {
  return (
    <section
      id="ecosystem"
      data-testid="ecosystem-section"
      className="relative bg-[#f5f5f7] text-black pt-16 md:pt-20 pb-10 md:pb-12 border-t overflow-hidden"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16 max-w-3xl">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[color:var(--primary-accent)] mb-6">
              The Actalink Ecosystem
            </p>
          </Reveal>
          {/* <h2 className="font-display text-black text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.02]">
            <RevealLineOnScroll>One platform for global</RevealLineOnScroll>
            <RevealLineOnScroll delay={0.08}>stablecoin payments.</RevealLineOnScroll>
          </h2> */}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {ECOSYSTEM.map((item, i) => (
            <motion.div
              key={item.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, ease: EASE, delay: i * 0.1 }}
              className={`group rounded-2xl border p-8 min-h-[160px] flex flex-col justify-between ${
                item.active ? "text-white" : "bg-white text-black"
              }`}
              style={{
                background: item.active ? "var(--primary-accent)" : undefined,
                borderColor: item.active
                  ? "var(--primary-accent)"
                  : "var(--border-light)",
              }}
              data-testid={`ecosystem-card-${item.name.toLowerCase()}`}
            >
              <div className="flex items-start justify-between">
                <span
                  className={`font-mono-str text-xs ${
                    item.active ? "text-white/70" : "text-black/30"
                  }`}
                >
                  0{i + 1}
                </span>
                <ArrowUpRight
                  size={18}
                  className={
                    item.active
                      ? "text-white/80"
                      : "text-black/25 group-hover:text-[color:var(--primary-accent)] transition-colors duration-300"
                  }
                />
              </div>
              <div>
                <h3 className="font-display text-2xl md:text-3xl font-bold tracking-tight mb-2">
                  {item.name}
                </h3>
                <p
                  className={`text-sm ${item.active ? "text-white/80" : "text-black/50"}`}
                >
                  {item.role}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <p className="text-black/50 text-lg">
              From wallet to merchant settlement.
            </p>
            <p className="font-display text-2xl md:text-4xl font-bold tracking-tight">
              One network. Every payment. Anywhere.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
